import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { TemplatesState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: TemplatesState = {
    templates: [],
    allTemplates: [],
    multichannelTemplates: [],
};


export const template: Module<TemplatesState,RootState> = {
    state,
    getters,
    actions,
    mutations
};